import Vue from 'vue';
import AlertV2 from '@/components/copyright/basics/alertV2/index.vue'
let $vm

const plugin = {
  install (vue, pluginOptions = {}) {
    const TsaAlertV2 = vue.extend(AlertV2)
    if (!$vm) {
      $vm = new TsaAlertV2({
        el: document.createElement('div')
      })
      document.body.appendChild($vm.$el)
    }

    const toast = {
      show (options = {}) {
        $vm.show = true
        $vm.title = options.title || '提示'
        $vm.message = options.message
        $vm.type = options.type || 'warn'
        $vm.confirmButtonText = options.confirmButtonText || '确定'
        $vm.onClose = options.onClose
        $vm.onConfirm = options.onConfirm
      },
      hide () {
        $vm.show = false
      }
    }
    if (!vue.prototype.$TsaAlertV2) {
      vue.prototype.$TsaAlertV2 = toast
    }
  }
}
export default plugin